import { useCallback, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

import { isArray, useMount, useUnmount } from '@cutwise/utils';

import CreateProjectModal from '@/dmdrive/drive/components/CreateProjectModal/CreateProjectModal';
import Upload3DModelButton from '@/dmdrive/drive/components/Upload3DModelButton/Upload3DModelButton';
import { useStore } from '@/dmdrive/store';

import { ProjectsListHeader } from './ProjectsListPage.styles';

import ProjectsList from './ProjectsList/ProjectsList';

function ProjectsListPage() {
  const { init, dispose } = useStore('driveStore');
  const { isCreateProjectModalOpen, openCreateProjectModal, closeCreateProjectModal } = useStore('driveStore');

  const uploadButtonRef = useRef<HTMLLabelElement>(null);

  const [filesToUpload, setFilesToUpload] = useState<File[]>([]);

  const onSelectFiles = useCallback((files: Nullable<File[]>) => {
    if (isArray(files)) {
      setFilesToUpload(files!);
    }

    openCreateProjectModal();
  }, []);

  const onCreateNewProject = useCallback(() => uploadButtonRef.current?.click(), [uploadButtonRef.current]);

  useMount(init);

  useUnmount(() => {
    setFilesToUpload([]);

    dispose();
  });

  return (
    <Container maxWidth="lg">
      <Grid container spacing={2}>
        <Grid size={12}>
          <ProjectsListHeader>
            <Typography variant="h4">Projects</Typography>

            <Upload3DModelButton linkRef={uploadButtonRef} title="Create project" onSelectFile={onSelectFiles} />
          </ProjectsListHeader>
        </Grid>

        <Grid size={12}>
          <ProjectsList onCreateNewProject={onCreateNewProject} />
        </Grid>
      </Grid>

      <CreateProjectModal files={filesToUpload} onClose={closeCreateProjectModal} isOpen={isCreateProjectModalOpen} />
    </Container>
  );
}

export default observer(ProjectsListPage);
